<template>
    <div class="c-panel c-panel--small">

        <h3 class="margin-b-24">Wachtwoord aanpassen</h3>

        <c-form @submit:valid="submit" ref="form">
              
            <c-input 
                type="email" 
                name="email"
                required
                v-model="email" 
                :label="'E-mailadres'" />

            <c-password 
                name="password"
                id="password"
                required
                v-model="password" 
                data-pattern="password"
                data-error-message="Je wachtwoord moet minimaal uit 1 hoofdletter, 1 kleine letter, 1 cijfer en 1 speciale karakter bestaan en minimaal 8 karakters lang zijn"
                autocomplete="new-password"
                :label="'Nieuw Wachtwoord'" />

            <c-password 
                name="confirm"
                required
                data-pattern="password"
                data-equalto="password" 
                v-model="confirm" 
                :label="'Herhaal wachtwoord'" />

            <c-button type="submit" class="c-btn--expanded margin-t-32 margin-b-16">Wachtwoord vernieuwen</c-button>
        </c-form>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
    mixins: [Form],
    data() {
        return {
            confirm: '',
            password: ''
        }
    },
    methods: {
        submit() {
            this.$xhr.post('/api/auth/password-reset', {
                email: this.email,
                password: this.password,
                password_confirmation: this.confirm,
                token: this.$route.params.token
            }).then( () => {
                this.$router.push({name: 'password-forget-restore-success'});
            }).catch( () => {
                if (e instanceof ValidationError) {
                    this.$refs.form.setErrors(e.errors);
                }
                this.error = true;
            });
        }
    }
}
</script>